import AnchorButton from './anchor_button';

export default AnchorButton;
